module.exports = __webpack_public_path__ + "static/BOOKING FORM BOTH ROOMS-9d3388b513c921f138b01100475780c7.pdf";